import React from "react";
import RealEstateImg from "../../../assets-user/RealEstate.png";
import propertiesImg from "../../../assets-user/properties.png";
import buildingImg from "../../../assets-user/building.png";
import realEstateImg2 from "../../../assets-user/realEstate2.png";
import logo1Img from "../../../assets-user/logo1.png";
import rdeImg from "../../../assets-user/rde.png";
import loremIpsumImg from "../../../assets-user/loremIpsum.png";
import homeServideImg from "../../../assets-user/homeService.png";

const LogoCarousel = () => {
  const logos = [
    { img: RealEstateImg, alt: "Real Estate" },
    { img: propertiesImg, alt: "Properties" },
    { img: buildingImg, alt: "Building" },
    { img: realEstateImg2, alt: "Real Estate Company" },
    { img: logo1Img, alt: "Walnut Ventures" },
    { img: rdeImg, alt: "RDE School Group" },
    { img: loremIpsumImg, alt: "Lorem Ipsum" },
    { img: homeServideImg, alt: "Home Service" },
  ];

  return (
    <div className="w-full bg-[#ECF6FF] px-4 sm:px-6 lg:px-10 py-10 overflow-hidden">
      {/* Auto-scrolling logo row */}
      <div className="overflow-hidden relative">
        <div className="flex items-center gap-6 sm:gap-8 md:gap-12 lg:gap-16 xl:gap-20 animate-logo-scroll">
          {[...logos, ...logos].map((logo, index) => (
            <div
              key={index}
              className="flex-shrink-0 bg-white rounded-full shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100"
            >
              <img
                src={logo.img}
                alt={logo.alt}
                className="rounded-full w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 lg:w-32 lg:h-32 object-contain transition-all duration-300"
              />
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes logoScroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-100%);
          }
        }
        .animate-logo-scroll {
          animation: logoScroll 30s linear infinite;
        }
        .animate-logo-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
};

export default LogoCarousel;

// import React from "react";
// import RealEstateImg from "../../../assets-user/RealEstate.png";
// import propertiesImg from "../../../assets-user/properties.png";
// import buildingImg from "../../../assets-user/building.png";
// import realEstateImg2 from "../../../assets-user/realEstate2.png";
// import logo1Img from "../../../assets-user/logo1.png";
// import rdeImg from "../../../assets-user/rde.png";
// import loremIpsumImg from "../../../assets-user/loremIpsum.png";
// import homeServideImg from "../../../assets-user/homeService.png";

// const LogoCarousel = () => {
//   const logos = [
//     { img: RealEstateImg, alt: "Real Estate" },
//     { img: propertiesImg, alt: "Properties" },
//     { img: buildingImg, alt: "Building" },
//     { img: realEstateImg2, alt: "Real Estate Company" },
//     { img: logo1Img, alt: "Walnut Ventures" },
//     { img: rdeImg, alt: "RDE School Group" },
//     { img: loremIpsumImg, alt: "Lorem Ipsum" },
//     { img: homeServideImg, alt: "Home Service" },
//   ];

//   return (
//     <div className="w-full bg-[#ECF6FF] px-4 sm:px-6 lg:px-10 py-10 overflow-hidden">
//       <div className="mx-auto">
//         {/* All Devices - Auto Scrolling */}
//         <div className="overflow-hidden relative">
//           <div className="flex items-center gap-6 sm:gap-8 md:gap-12 lg:gap-16 xl:gap-20 animate-scroll-logos">
//             {[...logos, ...logos].map((logo, index) => (
//               <div
//                 key={index}
//                 className="flex-shrink-0 bg-white rounded-full shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100"
//               >
//                 <img
//                   src={logo.img}
//                   alt={logo.alt}
//                   className="rounded-full w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 lg:w-32 lg:h-32 object-contain transition-all duration-300"
//                 />
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       <style>{`
//         @keyframes scrollLogos {
//           0% {
//             transform: translateX(0);
//           }
//           100% {
//             transform: translateX(-100%);
//           }
//         }
//         .animate-scroll-logos {
//           display: flex;
//           animation: scrollLogos 30s linear infinite;
//         }
//         .animate-scroll-logos:hover {
//           animation-play-state: paused;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default LogoCarousel;
